import React, {Component} from 'react';

import services from '../../services';

import Modal from '../Modal';
import CiqaFileGrid from './ciqaFileGrid';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywords: {}
        };
        
    }

    componentWillReceiveProps(nextProps) {
        const pid = nextProps.pid;

        if(pid) {
            this.setState({
                keywords: {
                    pid,
                    v: Date.now()
                }
            })
        }
        
    }

    handleSumbit() {
    }
    
    handleCancel() {
        this.props.handleCancel();
    }

    render() {
        return (
            <Modal title="附件" 
            styleName="root-attachment" 
            visible={this.props.visible}  
            handleSumbit={this.handleSumbit.bind(this)} 
            handleCancel={this.handleCancel.bind(this)}>
                <CiqaFileGrid keywords={this.state.keywords} service={services.ciqa.attachment} ismodal="true" />
            </Modal>
        )
    }
}